import React from "react"

const HistoricalAccessToolContext = React.createContext(null)

export default HistoricalAccessToolContext
